import { AjoutFiltreDialogComponent } from './ajout-modal/ajout.modal';
import { AsiDialogService } from '@asi-ngtools/lib';
import { FiltreItems, FiltreItem } from './filtre-item';
import { Component, EventEmitter, Input, Output } from "@angular/core";
import * as lodash from "lodash";

@Component({
  selector: 'serveur-resultats-vos-filtres',
  templateUrl: './vos-filtres.component.html'
})
export class ServeurResultatsVosFiltresComponent {

  @Input() titre: string
  @Input() filtre: FiltreItems;

  @Output() onItemRemoved = new EventEmitter<FiltreItem>();
  @Output() onCreated = new EventEmitter<FiltreItems>();
  @Output() onUpdated = new EventEmitter<{filtre : FiltreItems, name : string}>();

  constructor(private asiDialogService: AsiDialogService) {
  }

  sauvegarderFiltre() {
    let creation = !this.filtre.name;
    let dialog = this.asiDialogService.fromComponent(AjoutFiltreDialogComponent, null);
    dialog.getComponent().name = this.filtre.name;
    dialog.onDialogClose().subscribe((name: string) => {
      if (creation) {
        this.filtre.name = name;
        this.onCreated.emit(this.filtre);
      } else {
        let output = {
          filtre: this.filtre,
          name: name
        }
        this.onUpdated.emit(output);
      }
    });
  }

  remove(removedFiltre: FiltreItem, removedValue: any): void {
    if (removedValue == null) {
      lodash.remove(this.filtre.filtres, (filtre) => {
        return removedFiltre.code == filtre.code;
      });
    } else {
      lodash.remove(removedFiltre.value, (value) => {
        return removedValue == value;
      });
    }
    this.onItemRemoved.emit(removedFiltre);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/serveur-resultats/filtres/vos-filtres/vos-filtres.component.ts